import React, { useEffect, useState } from 'react';
import { GeetestConfig, GeetestSolution } from './Captcha.types';

const GEETEST_CONTAINER_ID = 'geetest-container-id' as const;
const GEETEST_SCRIPT_ID = 'geetest-script-id' as const;
const GEETEST_INIT_FN = 'initGeetest' as const;

type GeetestUnprocessedSolution = {
  geetest_challenge: string;
  geetest_validate: string;
  geetest_seccode: string;
};

type GeetestError = {
  code: string;
  error_code: string;
  msg: string;
  user_error: string;
};

export default function Geetest({
  onReady,
  onSuccess,
  onError,
  language,
  width,
  product,
  config,
}: Readonly<{
  onReady: () => void;
  onSuccess: (solution: GeetestSolution) => void;
  onError: (error: GeetestError) => void;
  language: string;
  width: string;
  product: 'float' | 'popup';
  config: GeetestConfig;
}>) {
  // @ts-expect-error missing window type
  const [scriptLoaded, setScriptLoaded] = useState(!!window[GEETEST_INIT_FN]);
  const [geetestObj, setGeetestObj] = useState<any>(null);

  const loadScript = () => {
    let script = document.getElementById(GEETEST_SCRIPT_ID) as HTMLScriptElement | null;

    if (!script) {
      script = document.createElement('script');
      script.id = GEETEST_SCRIPT_ID;
      script.src = 'https://static.geetest.com/static/js/gt.0.5.0.js';
      document.head.appendChild(script);
    }

    script.onload = () => {
      setScriptLoaded(true);
    };
  };

  useEffect(() => {
    if (!scriptLoaded) {
      loadScript();
    }
  }, []);

  useEffect(() => {
    // @ts-expect-error missing window type
    if (scriptLoaded && window[GEETEST_INIT_FN]) {
      const { gt, challenge, success, newCaptcha } = config;
      // @ts-expect-error missing window type
      window[GEETEST_INIT_FN](
        {
          new_captcha: newCaptcha ?? false,
          lang: language,
          product,
          width,
          gt,
          challenge,
          offline: !success,
        },
        (geetestObj: any) => {
          setGeetestObj(geetestObj);

          geetestObj.onReady(() => {
            geetestObj.appendTo(`#${GEETEST_CONTAINER_ID}`);
            onReady();
          });

          geetestObj.onSuccess(() => {
            const {
              geetest_challenge: challenge,
              geetest_validate: validate,
              geetest_seccode: seccode,
            } = geetestObj.getValidate() as GeetestUnprocessedSolution;

            onSuccess({
              challenge,
              validate,
              seccode,
            });
          });

          geetestObj.onError((e: GeetestError) => {
            onError(e);
          });
        },
      );
    }
  }, [scriptLoaded]);

  useEffect(() => {
    if (geetestObj) {
      return () => {
        geetestObj.destroy();
      };
    }
  }, [geetestObj]);

  return <div id={GEETEST_CONTAINER_ID} className="w-100" />;
}
